import React, { useState, useEffect, useCallback } from "react";
import { TextField } from "@mui/material";
import { Grid, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Checkbox,
  MenuItem,
  Select,
  AppBar,
  Toolbar,
  Typography,
} from "@mui/material";
import Detail from "./Detail";
import LoginDialog from "./LoginDialog";
import NhanhOrders from "./Nhanh/NhanhOrders";
import NhanhDirectOrders from "./Nhanh/NhanhDirectOrders";
import "./App.css";

const columns = [
  { id: "batNbr", label: "Số Lô Nghiệp Vụ", minWidth: 100 },
  {
    id: "dateEnt",
    label: "Ngày giao dịch",
    minWidth: 100,
    format: (value) => value?.format("DD-MM-YYYY"),
  },
  {
    id: "toSiteID",
    label: "Mã Kho",
    minWidth: 100,
    // align: "right",
  },
  {
    id: "toSiteName",
    label: "Tên Kho",
    minWidth: 150,
    // align: "right",
  },
  {
    id: "descr",
    label: "Ghi Chú",
    minWidth: 150,
    // align: "right",
  },
  {
    id: "action",
    label: "Thao tác",
    minWidth: 120,
    align: "center",
  },
];

const transferColumns = [
  { id: "transferDocNbr", label: "Số Lô Nghiệp Vụ", minWidth: 100 },
  {
    id: "tranDate",
    label: "Ngày giao dịch",
    minWidth: 100,
    format: (value) => value?.format("DD-MM-YYYY"),
  },
  {
    id: "fromSiteID",
    label: "Mã kho đi",
    minWidth: 100,
    // align: "right",
  },
  {
    id: "fromSiteName",
    label: "Kho đi",
    minWidth: 150,
    // align: "right",
  },
  {
    id: "toSiteID",
    label: "Mã kho đến",
    minWidth: 100,
    // align: "right",
  },
  {
    id: "toSiteName",
    label: "Kho đến",
    minWidth: 150,
    // align: "right",
  },
  {
    id: "descr",
    label: "Ghi Chú",
    minWidth: 100,
    // align: "right",
  },
  {
    id: "action",
    label: "Thao tác",
    minWidth: 120,
    align: "center",
  },
];

const paymentColumns = [
  { id: "batNbr", label: "Số Lô Nghiệp Vụ", minWidth: 100 },
  {
    id: "completedDate",
    label: "Ngày tạo phiếu",
    minWidth: 100,
    format: (value) => value?.format("DD-MM-YYYY"),
  },
  {
    id: "docDate",
    label: "Ngày Chứng từ",
    minWidth: 100,
    format: (value) => value?.format("DD-MM-YYYY"),
  },
  {
    id: "descr",
    label: "Ghi Chú",
    minWidth: 150,
    // align: "right",
  },
  {
    id: "action",
    label: "Thao tác",
    minWidth: 120,
    align: "center",
  },
];

function App() {
  const [fromDate, setfromDate] = useState(dayjs());
  const [toDate, settoDate] = useState(dayjs());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1000);
  const [showDetail] = useState({});
  const [code, setCode] = useState("import");
  const [activeCode, setActiveCode] = useState("import");
  const [data, setData] = useState([]);
  const [selectedPaymentKeys, setSelectedPaymentKeys] = useState(new Set());
  const [paymentBatCode, setPaymentBatCode] = useState("012");
  const [paymentAccountCode, setPaymentAccountCode] = useState("11210202");
  const [isLoading, setIsLoading] = useState(false);

  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem("nhanh_admin");
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  });
  const [currentView, setCurrentView] = useState(() => {
    try {
      const saved = localStorage.getItem("nhanh_admin");
      return saved ? "nhanh_orders" : "dashboard";
    } catch (e) {
      return "dashboard";
    }
  }); // 'dashboard' or 'nhanh_orders'
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);

  useEffect(() => {
    if (!user && currentView === "nhanh_orders") {
      setCurrentView("dashboard");
    }
  }, [user, currentView]);

  const handleLoginSuccess = () => {
    const userData = { username: "admin", role: "admin" };
    localStorage.setItem("nhanh_admin", JSON.stringify(userData));
    setUser(userData);
    setCurrentView("nhanh_orders");
  };

  const handleLogout = () => {
    localStorage.removeItem("nhanh_admin");
    setUser(null);
    setCurrentView("dashboard");
  };
  // const [lots, setLots] = useState([]);

  // useEffect(() => {
  //   const sheetId = "1zxbifLf_tOhaTECAYaTH0dZXKLOxIa3GKRiJMND61rE"; // thay ID của bạn
  //   const gid = "0"; // ID của sheet, thường là 0 nếu chỉ có 1 sheet

  //   const url = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:csv&gid=${gid}`;
  //   fetch(url)
  //     .then((res) => res.text())
  //     .then((csvText) => {
  //       const lots = csvText.split("\n").map((row) => row.split(","));
  //       console.log("ak", lots); // Mảng 2 chiều, mỗi dòng là 1 array
  //       setLots(lots);
  //     });
  // }, [activeCode]);

  const getPaymentRowKey = useCallback((row) => {
    return (
      row?.batNbr ||
      row?.docNbr ||
      row?.refNbr ||
      row?.id ||
      row?.slnv ||
      // fallback: if row is basically an item
      row?.orderNbr ||
      JSON.stringify({
        batNbr: row?.batNbr,
        docDate: row?.docDate,
        completedDate: row?.completedDate,
      })
    );
  }, []);

  const handleFromDateChange = (newValue) => {
    console.log("User selected date:", newValue?.format("DD-MM-YYYY"));
    setfromDate(newValue);
  };

  const handleToDateChange = (newValue) => {
    console.log("User selected date:", newValue?.format("DD-MM-YYYY"));
    settoDate(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangeCode = (event) => {
    const newCode = event.target.value;
    setCode(newCode);
    setActiveCode(newCode);
    setPage(0);
    if (newCode !== "payment") {
      setSelectedPaymentKeys(new Set());
    } else {
      setPaymentBatCode("012");
      setSelectedPaymentKeys(new Set());
    }
    handleGetData(newCode);
  };

  const handlePaymentBatCodeChange = (event) => {
    const next = event.target.value;
    setPaymentBatCode(next);
    setSelectedPaymentKeys(new Set());
    setPage(0);
  };

  const handlePaymentAccountCodeChange = (event) => {
    const next = event.target.value;
    setPaymentAccountCode(next);
    setSelectedPaymentKeys(new Set());
    setPage(0);
  };

  const handleGetData = useCallback(
    async (overrideCode) => {
      const usedCode = overrideCode || code;
      const formattedFromDate = fromDate?.format("DD-MM-YYYY");
      const formattedToDate = toDate?.format("DD-MM-YYYY");

      setIsLoading(true);

      try {
        // If user selected payment option, call paymentreceivable endpoint and render its data
        if (usedCode === "payment") {
          try {
            const urlPayment = `https://dms-service-prod.anvy.vn/api/paymentreceivable/internal?GECpnyID=AMH&FromDate=${formattedFromDate}&ToDate=${formattedToDate}`;

            const response = await fetch(urlPayment, {
              method: "GET",
              headers: {
                Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjEiLCJuYmYiOjE3MzY5OTg1NzMsImV4cCI6MTgyMzM5ODU3MywiaWF0IjoxNzM2OTk4NTczfQ.FuYfiroIKJvnNZUn2RC9emIh8NqFQe2PMSgQzoWajFI`,
              },
            });
            const result = await response.json();
            console.log("payment result", result.data);
            const rows = Array.isArray(result.data) ? result.data : [];

            setData(rows);
            setSelectedPaymentKeys(new Set());
            setActiveCode(usedCode);
          } catch (error) {
            console.error("Lỗi khi gọi payment API:", error);
          }
          return;
        }

        try {
          const url = `https://dms-service-prod.anvy.vn/api/inventory/${usedCode}?GECpnyID=AMH&FromDate=${formattedFromDate}&ToDate=${formattedToDate}`;

          const response = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjEiLCJuYmYiOjE3MzY5OTg1NzMsImV4cCI6MTgyMzM5ODU3MywiaWF0IjoxNzM2OTk4NTczfQ.FuYfiroIKJvnNZUn2RC9emIh8NqFQe2PMSgQzoWajFI`,
            },
          });
          const result = await response.json();
          console.log("result main", result.data);
          setActiveCode(usedCode);
          setData(result.data);
          setSelectedPaymentKeys(new Set());
        } catch (error) {
          console.error("Lỗi khi gọi API:", error);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [code, fromDate, toDate],
  );

  useEffect(() => {
    handleGetData();
  }, [handleGetData]);

  const togglePaymentRow = (row) => {
    const key = getPaymentRowKey(row);
    setSelectedPaymentKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const selectAllPaymentRows = (rowsToSelect) => {
    setSelectedPaymentKeys((prev) => {
      const next = new Set(prev);
      rowsToSelect.forEach((r) => next.add(getPaymentRowKey(r)));
      return next;
    });
  };

  const unselectAllPaymentRows = (rowsToUnselect) => {
    setSelectedPaymentKeys((prev) => {
      const next = new Set(prev);
      rowsToUnselect.forEach((r) => next.delete(getPaymentRowKey(r)));
      return next;
    });
  };

  const handleActionClick = (row) => {
    console.log("Clicked row data:", row);
    const result = [];

    row.items.forEach((item) => {
      item.lots.forEach((lot) => {
        const formatQty = (qty, itemObj) => {
          const unit = (itemObj?.unit || "").toString().toLowerCase();
          if (unit === "kg") return qty;
          const numeric = Number(qty);
          if (Number.isNaN(numeric)) return qty;
          if (unit === "thùng" || unit === "thung") {
            const x10Codes = ["AVMNL010018303", "AVMNL010013606"];
            const multiplier = x10Codes.includes(itemObj?.invtID) ? 10 : 3.7;
            return Math.round(numeric * multiplier * 10) / 10;
          }
          return Math.round((numeric / 2) * 10) / 10;
        };

        result.push({
          id:
            row.batNbr?.replace("HYN", "") ||
            row.transferDocNbr?.replace("HYN", ""),
          date: dayjs(row.dateEnt).format("DD/MM/YYYY"),
          descr: row.descr,
          debit: activeCode === "export" ? "" : "155",
          credit: "154",
          invtID: item.invtID,
          invtName: item.invtName,
          lotSerNbr: lot.lotSerNbr,
          qty: formatQty(lot.qty, item),
          expDate: dayjs(lot.expDate).format("DD/MM/YYYY"),
          fromSiteName: row.fromSiteName,
          fromSiteNameNK: "",
          fromSiteID: row.fromSiteID,
          fromSiteIDNK: "",
          toSiteName: row.toSiteName || row.siteName,
          toSiteID: row.toSiteID || row.siteID,
        });
      });
    });
    console.log("Clicked row data: result", result);
    handleExportExcel(result);
  };

  const handleExportPaymentExcel = (rows) => {
    console.log("Exporting payment rows:", rows);
    const rowsArr = Array.isArray(rows) ? rows : [rows];

    // Fixed values (columns D, E, G, H, L) as in the provided template
    const FIX_TK_NO = paymentAccountCode || "11210202";
    const FIX_TK_CO = "1311";
    const FIX_DONG_TIEN = "KMT0105";
    const FIX_MANG_KINH_DOANH = "Medherb";
    const FIX_KENH_PHAN_PHOI = "Phòng khám/phòng mạch";

    const headers =
      paymentAccountCode === "11210202"
        ? [
          "Ngày",
          "[Đối tượng công nợ] Mã",
          "Tên KH",
          "TK nợ",
          "TK có",
          "Tiền VND",
          "[Dòng tiền] Mã",
          "Mảng kinh doanh",
          "Số đơn hàng",
          "Ngày đơn hàng",
          "Mã NVBH",
          "Kênh phân phối",
        ]
        : [
          "Ngày",
          "[Đối tượng công nợ] Mã",
          "Tên KH",
          "[Đối tượng công nợ] Mã",
          "Tên KH",
          "TK nợ",
          "TK có",
          "Tiền VND",
          "Mảng kinh doanh",
          "Số đơn hàng",
          "Ngày đơn hàng",
          "Mã NVBH",
          "Kênh phân phối",
        ];

    const pickFirst = (obj, keys) => {
      for (const key of keys) {
        const val = obj?.[key];
        if (val !== undefined && val !== null && `${val}`.trim() !== "")
          return val;
      }
      return "";
    };

    const formatDateVN = (value) => {
      if (!value) return "";
      const d = dayjs(value, [
        "YYYY-MM-DD",
        "YYYY/MM/DD",
        "DD-MM-YYYY",
        "DD/MM/YYYY",
        dayjs.ISO_8601,
      ]);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    };

    const formatVND = (value) => {
      if (value === null || value === undefined || value === "") return "";
      const n =
        typeof value === "number"
          ? value
          : Number(String(value).replace(/[^\d-]/g, ""));
      if (Number.isNaN(n)) return "";
      return new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 0,
      }).format(n);
    };

    const toNumberVND = (value) => {
      if (value === null || value === undefined || value === "") return 0;
      if (typeof value === "number" && Number.isFinite(value)) return value;
      const n = Number(String(value).replace(/[^\d-]/g, ""));
      return Number.isNaN(n) ? 0 : n;
    };

    const normalize = (v) => (v === null || v === undefined ? "" : v);

    const rowsData = rowsArr.flatMap((row) => {
      const rowDate = pickFirst(row, [
        "docDate",
        "completedDate",
        "paymentDate",
        "tranDate",
        "date",
      ]);
      const ngay =
        formatDateVN(rowDate) || dayjs(fromDate).format("DD/MM/YYYY");

      const lineItems = Array.isArray(row?.items) ? row.items : [row];

      // Group lines by orderNbr so each order is 1 output row.
      const groups = new Map();

      lineItems.forEach((it, idx) => {
        const orderNbr = pickFirst(it, [
          "orderNbr",
          "orderNumber",
          "soDonHang",
          "sONbr",
          "soNbr",
        ]);

        const groupKey = orderNbr || `__NO_ORDER__${idx}`;

        const amountVal = pickFirst(it, [
          "paymentAmount",
          "amount",
          "totalAmount",
          "vndAmount",
          "amt",
        ]);

        const existing = groups.get(groupKey);
        if (!existing) {
          groups.set(groupKey, {
            sample: it,
            orderNbr,
            amountSum: toNumberVND(amountVal),
          });
        } else {
          existing.amountSum += toNumberVND(amountVal);
        }
      });

      return Array.from(groups.values()).map((g) => {
        const it = g.sample;

        const partnerCode = pickFirst(it, [
          "custID",
          "invoiceCustID",
          "arCustID",
          "customerID",
          "custCode",
          "customerCode",
        ]);

        const name = pickFirst(it, [
          "custName",
          "invoiceCustName",
          "customerName",
          "partyName",
          "name",
        ]);

        const orderDate = pickFirst(it, ["orderDate", "ngayDonHang", "soDate"]);

        const salesCode = pickFirst(it, [
          "slsperID",
          "salesPersonID",
          "salesCode",
          "nvbhCode",
          "mnvbh",
        ]);

        let listColums =
          paymentAccountCode === "11210202"
            ? [
              ngay,
              partnerCode,
              name,
              FIX_TK_NO,
              FIX_TK_CO,
              formatVND(g.amountSum),
              FIX_DONG_TIEN,
              FIX_MANG_KINH_DOANH,
              g.orderNbr,
              formatDateVN(orderDate),
              salesCode,
              FIX_KENH_PHAN_PHOI,
            ]
            : [
              ngay,
              partnerCode,
              name,
              partnerCode,
              name,
              FIX_TK_NO,
              FIX_TK_CO,
              formatVND(g.amountSum),
              FIX_MANG_KINH_DOANH,
              g.orderNbr,
              formatDateVN(orderDate),
              salesCode,
              FIX_KENH_PHAN_PHOI,
            ];

        return listColums.map(normalize);
      });
    });

    const wsData = [[], ["Khách hàng thanh toán"], [], headers, ...rowsData];

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    worksheet["!merges"] = [{ s: { r: 1, c: 0 }, e: { r: 1, c: 11 } }];
    worksheet["!cols"] =
      paymentAccountCode === "11210202"
        ? [
          { wch: 12 },
          { wch: 20 },
          { wch: 28 },
          { wch: 10 },
          { wch: 8 },
          { wch: 14 },
          { wch: 12 },
          { wch: 16 },
          { wch: 16 },
          { wch: 16 },
          { wch: 18 },
          { wch: 22 },
        ]
        : [
          { wch: 12 },
          { wch: 20 },
          { wch: 28 },
          { wch: 20 },
          { wch: 28 },
          { wch: 10 },
          { wch: 8 },
          { wch: 14 },
          { wch: 16 },
          { wch: 16 },
          { wch: 16 },
          { wch: 18 },
          { wch: 22 },
        ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Thu tien");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const nameHint =
      rowsArr?.[0]?.batNbr ||
      rowsArr?.[0]?.id ||
      (Array.isArray(rowsArr?.[0]?.items)
        ? rowsArr[0].items?.[0]?.orderNbr
        : "") ||
      "data";
    saveAs(blob, `ThuTien_${nameHint}.xlsx`);
  };

  const handleExcelMeInvoice = (row) => {
    const transferDocNbr = (
      row?.transferDocNbr?.replace("HYN", "") || ""
    ).toString();
    const tranDate = row?.tranDate
      ? new Date(row.tranDate).toLocaleDateString("vi-VN")
      : "";

    const title =
      "File mẫu danh sách phiếu xuất kho kiêm vận chuyển hàng hóa nội bộ để nhập vào phần mềm";

    const headers = [
      "Số thứ tự PXK (*)",
      "Ngày PXK",
      "Số lệnh điều động (*)",
      "Ngày lệnh điều động",
      "Của",
      "Về việc",
      "Địa chỉ kho xuất hàng (*)",
      "Tên người xuất hàng",
      "Tên người vận chuyển",
      "Hợp đồng vận chuyển",
      "Phương tiện vận chuyển (*)",
      "Đơn vị nhận hàng",
      "Mã số thuế đơn vị nhận hàng",
      "Địa điểm nhận hàng (*)",
      "Tên người nhận hàng",
      "Tên hàng (*)",
      "Mã hàng",
      "ĐVT",
      "Số lô",
      "Số lượng thực xuất",
      "Số lượng thực nhập",
      "Đơn giá",
      "Thành tiền",
    ];

    const fromSiteName = (row?.fromSiteName || "").toString();
    const toSiteName = (row?.toSiteName || "").toString();
    // const fromSiteID = (row?.fromSiteID || "").toString();
    // const toSiteID = (row?.toSiteID || "").toString();
    // const descr = (row?.descr || "").toString();

    const normalizeText = (value) =>
      (value || "").toString().replace(/\s+/g, " ").trim();

    const normalizeLotSerNbr = (value) => {
      const text = normalizeText(value);
      if (!text) return "";

      // Lô bắt đầu bằng YC: giữ nguyên, không xử lý tiếp
      if (text.startsWith("YC")) {
        return text;
      }

      const dashIndex = text.indexOf("-");
      if (dashIndex === -1) return text;
      const prefix = text.slice(0, dashIndex);
      if (/[^0-9]/.test(prefix)) {
        return normalizeText(text.slice(dashIndex + 1));
      }
      return text;
    };

    // Template expects 22 columns (match `headers` length).
    // We repeat document-level fields for each item/lot line.
    const baseDocCols = [
      tranDate,
      transferDocNbr,
      tranDate,
      fromSiteName,
      "Vận chuyển nội bộ",
      fromSiteName,
      "", // Tên người xuất hàng
      "", // Tên người vận chuyển
      "", // Hợp đồng vận chuyển
      "Ô tô", // Phương tiện vận chuyển (*)
      toSiteName, // Đơn vị nhận hàng
      "", // Mã số thuế đơn vị nhận hàng
      toSiteName, // Địa điểm nhận hàng (*)
      "", // Tên người nhận hàng
    ];

    let runningIndex = 1;
    const items = Array.isArray(row?.items) ? row.items : [];

    const exampleRows = items.flatMap((item) => {
      const lots =
        Array.isArray(item?.lots) && item.lots.length > 0
          ? item.lots
          : [{ qty: item?.qty }];

      return lots.map((lot) => {
        const name = normalizeText(item?.invtName);
        const code = normalizeText(item?.invtID);
        const unit = normalizeText(item?.unit);
        const qty = lot?.qty ?? item?.qty ?? "";
        const lotSerNbr = normalizeLotSerNbr(lot?.lotSerNbr);

        const rowData = [
          runningIndex, // Số thứ tự PXK (*)
          ...baseDocCols, // Ngày PXK ... Tên người nhận hàng
          name, // Tên hàng (*)
          code, // Mã hàng
          unit, // ĐVT
          lotSerNbr, // Số lô
          qty, // Số lượng thực xuất
          "", // Số lượng thực nhập
          "", // Đơn giá
          "", // Thành tiền
        ];

        return rowData;
      });
    });

    const wsData = [
      [title],
      ["Hướng dẫn"],
      [
        "- Điền dữ liệu hóa đơn cần lập trên phần mềm vào các cột tương ứng trên file này",
      ],
      ["- Các cột có dấu (*) là những cột bắt buộc"],
      [
        "- Nếu muốn nhập thêm thông tin khác, người dùng có thể tự thêm cột trên file này",
      ],
      ["- Các dòng dữ liệu phía dưới chỉ là ví dụ minh họa"],
      [],
      headers,
      ...exampleRows,
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);

    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 11 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 11 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 11 } },
      { s: { r: 3, c: 0 }, e: { r: 3, c: 11 } },
      { s: { r: 4, c: 0 }, e: { r: 4, c: 11 } },
      { s: { r: 5, c: 0 }, e: { r: 5, c: 11 } },
    ];

    worksheet["!cols"] = [
      { wch: 16 },
      { wch: 14 },
      { wch: 20 },
      { wch: 20 },
      { wch: 35 },
      { wch: 30 },
      { wch: 35 },
      { wch: 22 },
      { wch: 22 },
      { wch: 22 },
      { wch: 22 },
      { wch: 35 },
      { wch: 30 },
      { wch: 35 },
      { wch: 22 },
      { wch: 22 },
      { wch: 22 },
      { wch: 14 },
      { wch: 22 },
      { wch: 22 },
      { wch: 22 },
      { wch: 14 },
      { wch: 14 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "PXK kiêm vận chuyển nội bộ",
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const safeDoc = transferDocNbr
      ? transferDocNbr.replace(/[^a-zA-Z0-9_-]/g, "_")
      : "template";
    saveAs(blob, `PXK_MeInvoice_${safeDoc}.xlsx`);
  };

  // - Nhập Kho Thành Phẩm => Kho đi để trống: tk kho 155
  // - Nhập Kho Từ DL Phòng Mạch => Kho đi điền: Kho DL phòng mạch: mã kho AVMKK1804 tk kho 15211
  // - Nhập Kho Từ Xưởng Giản Đơn=> Kho đi điền: Kho xưởng: mã kho AVMKK1605 tk kho 15211

  const handleExportExcel = (exportData) => {
    if (!exportData || exportData.length === 0) {
      console.warn("Không có dữ liệu để export");
      return;
    }

    let wsData = [];

    if (activeCode === "export") {
      wsData = [
        [
          "Ngày chứng từ",
          "Diễn giải",
          "Mã vật tư",
          "Mã sp",
          "Tên sp",
          "Số lượng(đvt)",
          "Số lô",
          "Hạn dùng",
          "Mã kho đi",
          "Kho đi",
          "Nợ",
          "Có",
          "Khoản mục chi phí",
          "Kênh",
          "Mảng kinh doanh",
          "Bộ phận",
          "Số lượng",
        ],
        ...exportData.map((item) => [
          item.date,
          item.descr,
          item.invtID,
          item.invtID,
          item.invtName,
          item.qty,
          item.lotSerNbr,
          item.expDate,
          item.toSiteID,
          item.toSiteName,
          "", // Nợ
          "155", // Có
          "", // Khoản mục chi phí
          "", // Kênh
          "Medherb",
          "Medherb",
          item.qty,
        ]),
      ];
    } else if (activeCode === "import") {
      wsData = [
        [
          "Ngày chứng từ",
          "Diễn giải",
          "Mã kho đi",
          "Kho đi",
          "Mã kho đến",
          "Kho đến",
          "Nợ",
          "Có",
          "Mã sp",
          "Tên sp",
          "Số lượng(đvt)",
          "Số lô",
          "Ngày sản xuất",
          "Hạn dùng",
          "Số lượng",
          "Phân xưởng",
          "ĐTCP",
        ],
        ...exportData.map((item) => [
          item.date,
          item.descr,
          item.fromSiteIDNK,
          item.fromSiteNameNK,
          item.toSiteID,
          item.toSiteName,
          item.debit || "",
          item.credit || "",
          item.invtID,
          item.invtName,
          item.qty,
          item.lotSerNbr,
          "",
          item.expDate,
          item.qty,
          "Xưởng sơ chế DL và vị thuốc YHCT",
          item.invtName,
        ]),
      ];
    } else {
      wsData = [
        [
          "Ngày chứng từ",
          "Diễn giải",
          "Mã kho đi",
          "Kho đi",
          "Mã kho đến",
          "Kho đến",
          "Nợ",
          "Có",
          "Mã sp",
          "Tên sp",
          "Số lượng(đvt)",
          "Số lô",
          "Ngày sản xuất",
          "Hạn dùng",
          "Số lượng",
          "Phân xưởng",
          "ĐTCP",
        ],
        ...exportData.map((item) => [
          item.date,
          item.descr,
          item.fromSiteID,
          item.fromSiteName,
          item.toSiteID,
          item.toSiteName,
          "155",
          "155",
          item.invtID,
          item.invtName,
          item.qty,
          item.lotSerNbr,
          "",
          item.expDate,
          item.qty,
          "",
          "",
        ]),
      ];
    }
    console.log("exportData", exportData);
    const worksheet = XLSX.utils.aoa_to_sheet(wsData);

    // ===== AUTO WIDTH =====
    const maxColWidths = wsData[0].map((_, colIdx) => {
      const maxLen = wsData.reduce((max, row) => {
        const cell = row[colIdx];
        const len = cell ? cell.toString().length : 0;
        return Math.max(max, len);
      }, 0);
      return { wch: maxLen + 2 }; // +2 để dễ nhìn
    });
    worksheet["!cols"] = maxColWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      activeCode === "import" ? "Nhap Kho" : "Xuat Kho",
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      data,
      activeCode === "export"
        ? `Xuat_Kho_${exportData[0]?.id || "data"}.xlsx`
        : activeCode === "import"
          ? `Nhap_Kho_${exportData[0]?.id || "data"}.xlsx`
          : `Chuyen_Kho_${exportData[0]?.id || "data"}.xlsx`,
    );
  };

  // const findCredit = (lot) => {
  //   const lotRow = lots.find((row) => {
  //     const lotInRow = row[3]?.replace(/"/g, "").trim();
  //     const searchLot = lot.toString().trim();
  //     return lotInRow === searchLot;
  //   });

  //   if (lotRow) {
  //     return lotRow[4].replace(/"/g, "");
  //   }

  //   return "";
  // };

  let columnData = [];
  if (activeCode === "transfer") columnData = transferColumns;
  else if (activeCode === "payment") columnData = paymentColumns;
  else columnData = columns;

  const pickFirst = (obj, keys) => {
    for (const key of keys) {
      const val = obj?.[key];
      if (val !== undefined && val !== null && `${val}`.trim() !== "")
        return val;
    }
    return "";
  };

  const getPaymentAccountFromRow = (row) => {
    const direct = pickFirst(row, ["accountCode"]);
    if (direct) return String(direct);

    const firstItem = Array.isArray(row?.items) ? row.items?.[0] : undefined;
    const fromItem = pickFirst(firstItem, ["accountCode"]);
    return fromItem ? String(fromItem) : "";
  };

  const filteredData =
    activeCode === "payment"
      ? data.filter((r) => {
        if (r?.batCode !== paymentBatCode) return false;
        // For "Áp thanh toán" (batCode 014), we don't filter by account.
        if (paymentBatCode === "014") return true;
        if (!paymentAccountCode) return true;
        return getPaymentAccountFromRow(r) === String(paymentAccountCode);
      })
      : data;

  const pagedRows = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const isPaymentApply = activeCode === "payment" && paymentBatCode === "014";

  // For "Áp thanh toán" (batCode 014), hide selection/export controls.
  const showPaymentSelection = activeCode === "payment" && !isPaymentApply;

  const baseColumns = isPaymentApply
    ? columnData.filter((c) => c.id !== "action")
    : columnData;

  const renderedColumns = showPaymentSelection
    ? [
      { id: "__select", label: "", minWidth: 48, align: "center" },
      ...baseColumns,
    ]
    : baseColumns;

  const selectedPaymentRows = showPaymentSelection
    ? filteredData.filter((r) => selectedPaymentKeys.has(getPaymentRowKey(r)))
    : [];

  const pagePaymentRows = showPaymentSelection ? pagedRows : [];
  const pageSelectedCount = showPaymentSelection
    ? pagePaymentRows.filter((r) =>
      selectedPaymentKeys.has(getPaymentRowKey(r)),
    ).length
    : 0;
  const pageAllSelected = showPaymentSelection
    ? pagePaymentRows.length > 0 && pageSelectedCount === pagePaymentRows.length
    : false;
  const pageIndeterminate = showPaymentSelection
    ? pageSelectedCount > 0 && pageSelectedCount < pagePaymentRows.length
    : false;

  return (
    <div className="App">
      <AppBar
        position="sticky"
        sx={{ backgroundColor: "#3F51B5", color: "#fff", zIndex: 1100, mb: 1 }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h6"
            className="app-bar-title"
            sx={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={() => setCurrentView("dashboard")}
          >
            {currentView === "nhanh_orders" || currentView === "nhanh_direct_orders" ? "" : "Hệ thống Kho DMS - MedEco"}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            {user ? (
              <>
                <Button
                  color="inherit"
                  className="nav-button"
                  variant={currentView === "dashboard" ? "outlined" : "text"}
                  sx={{ borderColor: "rgba(255,255,255,0.5)", color: "#fff" }}
                  onClick={() => setCurrentView("dashboard")}
                >
                  Trang Chủ DMS
                </Button>
                <Button
                  color="inherit"
                  className="nav-button"
                  variant={currentView === "nhanh_orders" ? "outlined" : "text"}
                  sx={{ borderColor: "rgba(255,255,255,0.5)", color: "#fff" }}
                  onClick={() => setCurrentView("nhanh_orders")}
                >
                  Đơn Hàng TMDT Nhanh.vn
                </Button>
                <Button
                  color="inherit"
                  className="nav-button"
                  variant={currentView === "nhanh_direct_orders" ? "outlined" : "text"}
                  sx={{ borderColor: "rgba(255,255,255,0.5)", color: "#fff" }}
                  onClick={() => setCurrentView("nhanh_direct_orders")}
                >
                  Đơn hàng tạo trực tiếp Nhanh.vn
                </Button>
                <Button
                  color="inherit"
                  className="nav-button"
                  variant="text"
                  sx={{ color: "rgba(255,255,255,0.85)", ml: 2 }}
                  onClick={handleLogout}
                >
                  Đăng xuất (admin)
                </Button>
              </>
            ) : (
              <Button
                color="inherit"
                className="nav-button"
                variant="outlined"
                sx={{ borderColor: "rgba(255,255,255,0.7)", color: "#fff" }}
                onClick={() => setLoginDialogOpen(true)}
              >
                Đăng nhập
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {showDetail.name ? (
        <Detail showDetail={showDetail} />
      ) : (
        <>
          {currentView === "nhanh_orders" ? (
            <NhanhOrders />
          ) : currentView === "nhanh_direct_orders" ? (
            <NhanhDirectOrders />
          ) : (
            <>
              <Grid
                container
                spacing={2}
                className="header"
                alignItems="flex-end"
              >
                <Grid item xs={12} sm={6} md={2} className="header-date">
                  <div className="header-date-label">Từ ngày</div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Chọn ngày"
                      value={fromDate}
                      format="DD-MM-YYYY"
                      maxDate={toDate}
                      onChange={handleFromDateChange}
                      size="small"
                      renderInput={(params) => <TextField {...params} />}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          InputLabelProps: { shrink: true },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <div className="header-date-label">Đến ngày</div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Chọn ngày"
                      value={toDate}
                      format="DD-MM-YYYY"
                      minDate={fromDate}
                      onChange={handleToDateChange}
                      size="small"
                      renderInput={(params) => <TextField {...params} />}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          InputLabelProps: { shrink: true },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <div>
                    <div className="header-date-label">Nghiệp vụ</div>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={code}
                      // label="Age"
                      onChange={handleChangeCode}
                      fullWidth
                      size="small"
                    >
                      <MenuItem value={"import"}>Nhập Kho</MenuItem>
                      <MenuItem value={"export"}>Xuất Kho</MenuItem>
                      <MenuItem value={"transfer"}>Chuyển Kho</MenuItem>
                      <MenuItem value={"payment"}>Thu tiền</MenuItem>
                    </Select>
                  </div>
                </Grid>
                {activeCode === "payment" && (
                  <>
                    <Grid item xs={12} sm={6} md={2}>
                      <div>
                        <div className="header-date-label">Loại phiếu</div>
                        <Select
                          value={paymentBatCode}
                          onChange={handlePaymentBatCodeChange}
                          fullWidth
                          size="small"
                        >
                          <MenuItem value={"012"}>Thu nợ trực tiếp</MenuItem>
                          <MenuItem value={"014"}>Áp thanh toán</MenuItem>
                        </Select>
                      </div>
                    </Grid>
                    {paymentBatCode !== "014" && (
                      <Grid item xs={12} sm={6} md={3}>
                        <div>
                          <div className="header-date-label">
                            Loại tài khoản
                          </div>
                          <Select
                            value={paymentAccountCode}
                            onChange={handlePaymentAccountCodeChange}
                            fullWidth
                            size="small"
                          >
                            <MenuItem value={"11210202"}>
                              MH-TGNH MB - CN Hưng Yên
                            </MenuItem>
                            <MenuItem value={"33511"}>
                              Chi phí phải trả
                            </MenuItem>
                          </Select>
                        </div>
                      </Grid>
                    )}
                  </>
                )}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={1}
                  sx={{ textAlign: "center", paddingTop: "25px" }}
                >
                  <div>
                    <Button
                      variant="outlined"
                      style={{
                        backgroundColor: "#3F51B5",
                        color: "#fff",
                        fontWeight: 600,
                        height: "40px",
                      }}
                      disabled={isLoading}
                      onClick={() => handleGetData()}
                    >
                      Lấy dữ liệu
                    </Button>
                  </div>
                </Grid>
              </Grid>
              <div className="content">
                <Paper
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {isLoading && (
                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255,255,255,0.6)",
                        zIndex: 2,
                        flexDirection: "column",
                      }}
                    >
                      <CircularProgress size={34} />
                      Đang tải dữ liệu...
                    </Box>
                  )}
                  <TableContainer
                    sx={{ maxHeight: `calc(100vh - 280px)`, minHeight: 300 }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {renderedColumns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                fontWeight: 600,
                                color: "#fff",
                                backgroundColor: "#3F51B5",
                              }}
                            >
                              {column.id === "__select" ? (
                                <Checkbox
                                  checked={pageAllSelected}
                                  indeterminate={pageIndeterminate}
                                  disabled={isLoading}
                                  onChange={(e) => {
                                    if (e.target.checked)
                                      selectAllPaymentRows(pagePaymentRows);
                                    else
                                      unselectAllPaymentRows(pagePaymentRows);
                                  }}
                                  sx={{ color: "#fff" }}
                                  inputProps={{
                                    "aria-label": "select all payments",
                                  }}
                                />
                              ) : (
                                column.label
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pagedRows.length === 0 ? (
                          <TableRow>
                            <TableCell
                              colSpan={renderedColumns.length}
                              align="center"
                              style={{ height: 300 }}
                            >
                              <div>{isLoading ? "" : "Không có dữ liệu"}</div>
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            {pagedRows.map((row, rowIndex) => {
                              const rowKey = row.id || row.slnv || rowIndex;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={rowKey}
                                >
                                  {renderedColumns.map((column) => {
                                    const value = row[column.id];
                                    if (column.id === "__select") {
                                      const paymentKey = getPaymentRowKey(row);
                                      return (
                                        <TableCell
                                          key={`${rowKey}-select`}
                                          align={column.align}
                                        >
                                          <Checkbox
                                            checked={selectedPaymentKeys.has(
                                              paymentKey,
                                            )}
                                            disabled={isLoading}
                                            onChange={() =>
                                              togglePaymentRow(row)
                                            }
                                            inputProps={{
                                              "aria-label": "select payment",
                                            }}
                                          />
                                        </TableCell>
                                      );
                                    }
                                    if (column.id === "action") {
                                      return (
                                        <TableCell
                                          key={`${rowKey}-action`}
                                          align={column.align}
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "auto",
                                          }}
                                        >
                                          {activeCode !== "payment" && (
                                            <Button
                                              variant="outlined"
                                              disabled={isLoading}
                                              onClick={() =>
                                                handleActionClick(row)
                                              }
                                            >
                                              Tải file excel GE
                                            </Button>
                                          )}
                                          {activeCode === "payment" &&
                                            paymentBatCode !== "014" && (
                                              <Button
                                                variant="outlined"
                                                sx={{ marginTop: "8px" }}
                                                disabled={isLoading}
                                                onClick={() =>
                                                  handleExportPaymentExcel(row)
                                                }
                                              >
                                                Tải Thu tiền
                                              </Button>
                                            )}
                                          {activeCode === "transfer" && (
                                            <Button
                                              variant="outlined"
                                              disabled={isLoading}
                                              onClick={() =>
                                                handleExcelMeInvoice(row)
                                              }
                                              sx={{ marginTop: "8px" }}
                                            >
                                              Tải file excel MeInvoice
                                            </Button>
                                          )}
                                        </TableCell>
                                      );
                                    }

                                    if (
                                      column.id === "dateEnt" ||
                                      column.id === "tranDate" ||
                                      column.id === "docDate" ||
                                      column.id === "completedDate"
                                    ) {
                                      return (
                                        <TableCell
                                          key={`${rowKey}-${column.id}`}
                                          align={column.align}
                                        >
                                          {value
                                            ? new Date(
                                              value,
                                            ).toLocaleDateString("vi-VN")
                                            : ""}
                                        </TableCell>
                                      );
                                    }

                                    if (activeCode === "payment") {
                                      // show raw values for payment mode
                                      const display =
                                        value === null || value === undefined
                                          ? ""
                                          : typeof value === "string"
                                            ? value
                                            : JSON.stringify(value);
                                      return (
                                        <TableCell
                                          key={`${rowKey}-${column.id}`}
                                          align={column.align}
                                        >
                                          {display}
                                        </TableCell>
                                      );
                                    }

                                    if (column.id === "toSiteID") {
                                      return (
                                        <TableCell
                                          key={`${rowKey}-${column.id}`}
                                          align={column.align}
                                        >
                                          {row?.toSiteID || row?.siteID}
                                        </TableCell>
                                      );
                                    }
                                    if (column.id === "toSiteName") {
                                      return (
                                        <TableCell
                                          key={`${rowKey}-${column.id}`}
                                          align={column.align}
                                        >
                                          {row?.toSiteName || row?.siteName}
                                        </TableCell>
                                      );
                                    }
                                    const displayVal =
                                      value && typeof value === "string"
                                        ? value.replace("HYN", "")
                                        : (value ?? "");
                                    return (
                                      <TableCell
                                        key={`${rowKey}-${column.id}`}
                                        align={column.align}
                                      >
                                        {displayVal}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {showPaymentSelection && (
                    <>
                      <Button
                        variant="outlined"
                        sx={{
                          marginLeft: 2,
                          position: "absolute",
                          left: 15,
                          bottom: 10,
                          cursor: "pointer",
                          zIndex: 100,
                        }}
                        disabled={selectedPaymentRows.length === 0}
                        onClick={() =>
                          handleExportPaymentExcel(selectedPaymentRows)
                        }
                      >
                        Export phiếu thu tiền đã chọn (
                        {selectedPaymentRows.length})
                      </Button>
                    </>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[1000, 2000, 5000]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Số dòng / trang:"
                  />
                </Paper>
              </div>
            </>
          )}
        </>
      )}

      <LoginDialog
        open={loginDialogOpen}
        onClose={() => setLoginDialogOpen(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  );
}

export default App;
